import { render, staticRenderFns } from "./setLatLng.vue?vue&type=template&id=5624e8ec&scoped=true&"
import script from "./setLatLng.vue?vue&type=script&lang=js&"
export * from "./setLatLng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../ys_expert-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5624e8ec",
  null
  
)

export default component.exports